@if (menuHidden) {
  <div class="relative w-full">
    <div class="absolute z-5 right-0">
      <div class="flex align-items-center gap-2 px-2">
        <div class="flex-1"></div>
        <p-button icon="pi pi-caret-down"
                  styleClass="p-button-rounded p-button-text"
                  [pTooltip]="view.isMobile ? '' : ('SHOW_MENU' | translate)" [showDelay]="400"
                  (click)="showMenu()"/>
      </div>
    </div>
  </div>
} @else {
  <div class="flex align-items-center gap-2 px-2 pb-2 pt-0 md:pt-2 fadeinup animation-duration-100">
    <div class="text-lg">
      {{'PLAYER_PROFILE_TITLE' | translate}}
    </div>
    <div class="flex-1"></div>
    @if (showSystem) {
      @switch (system())
      {
        @case ('web') {
          <i class="pi pi-globe pr-2"></i>
        }
        @case ('ios') {
          <i class="pi pi-apple pr-2"></i>
        }
        @case ('android') {
          <i class="pi pi-android pr-2"></i>
        }
      }
    }
    @if (playerProfile?.playerNumber) {
      <div class="flex align-items-center gap-1 cursor-pointer accent-hover pr-2"
           [pTooltip]="'YOUR_PLAYER_NUMBER' | translate" [showDelay]="400"
           [cdkCopyToClipboard]="playerProfile.playerNumber"
           (click)="restErrorHelper.showInfoMessageService('COPIED_TO_CLIPBOARD', 1500)">
        <span class="material-symbols-outlined text-xl">frame_person</span>
        {{playerProfile.playerNumber}}
      </div>
    }

    <p-button icon="pi pi-cog"
              styleClass="p-button-rounded p-button-text"
              [pTooltip]="'SETTINGS' | translate" [showDelay]="400"
              (click)="openSettings()"/> <!-- [label]="(view.isMobile ? '' : 'SETTINGS') | translate" -->

    <p-button icon="pi pi-question-circle"
              styleClass="p-button-rounded p-button-text"
              [pTooltip]="'HELP_AND_CONTACT' | translate" [showDelay]="400"
              (click)="openHelp()"/>
    <!--<p-button icon="pi pi-sign-out"
              styleClass="p-button-rounded p-button-text no-padding"
              [disabled]="isLoggingOut" [loading]="isLoggingOut"
              [pTooltip]="'LOGOUT' | translate" [showDelay]="400"
              (click)="logout()"/> --> <!-- [label]="(view.isMobile ? '' : 'LOGOUT') | translate" -->

    <p-button icon="pi pi-caret-up"
              styleClass="p-button-rounded p-button-text"
              [pTooltip]="'HIDE_MENU' | translate" [showDelay]="400"
              (click)="hideMenu()"/>
  </div>
}

<p-tabs [(value)]="selectedTabValue" [scrollable]="false">
  <p-tablist #tabList>
    @for (tab of items; track tab.value) {
      <p-tab [value]="tab.value" [routerLink]="tab.routerLink" class="flex items-center !gap-2">
        @if (tab.icon) {
          <i [class]="tab.icon"></i>
        }
        @if ((view.screenWidth > 390 || !tab.icon) && !(view.isMobile && (tab.value === 0 || tab.value === 1))) {
          <span>{{ tab.label | translate}}</span>
        }
      </p-tab>
    }
  </p-tablist>
</p-tabs>
